var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"title":_vm.title,"body-style":_vm.bodyStyles,"footer":null},on:{"cancel":function($event){return _vm.$emit('onClose')}}},[(_vm.image)?_c('img',{attrs:{"src":require(`@/app/chatbots/assets/${_vm.image}`)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }